import dayjs from 'dayjs';
import { ConsumptionAdjustmentMethod } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/consumption-adjustment-method.enum';
import {
  BufferSettingsUpdateRequest,
  ConsumptionRateOptions,
  ConsumptionRateUpdateRequest,
  EventName,
  FeedReserve,
  InventoryLog,
  ManualInventoryUpdateRequest,
  OfdSettings,
  OfdSettingsRequest,
  Timeline,
} from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-settings.type';

//get
export const OFDSettingsData: OfdSettings = {
  isOfdEnabled: true,
  placeRecommendedOrdersAutomatically: true,
  siloCapacity: 400000, //maxSiloCapacity
  capacityBuffer: 0.03, // staticBuffer
  consumptionBufferDays: 4, //adaptive buffer days
  buffer: 108705.92,
  consumptionRateAdjustmentMethod: ConsumptionAdjustmentMethod.historicalAverage,
  consumptionRateAdjustmentDays: 7, //dailyConsumtionRate value between 3-30 days
  manualConsumptionRateCoefficient: null, //Slider daily consumption rate (percentage) //Can be Null
  currentConsumptionRate: 24176.48, //estimated Subtraction (consumptionRate)
  minimumRecommendationQuantity: 500,
  orderFrequency: null, //only for Chile (unknown) //can be null
  deliveryExpected: false, // if false no delviery expcted (feed inventory)
  deliveredQuantity: 0, // Expected delivery quantity
  originalConsumptionRate: 18890.9, //Value from sea cloud
  manualInventory: {
    inventory: 251081.0, //starting inventory
    updatedDate: '2025-04-24T08:26:38.04827+00:00', //lastManualUpdate date
    afterDelivery: false, //before or after delivery
    updatedByEmail: 'user1@email.com',
  },
  inventoryExplanation: {
    utcDate: '2025-04-29',
    startingInventory: 105000,
    startingPercentOfCapacity: 0.26,
    events: [
      {
        updatedBy: 'loke_vonbagh@crgl-thirdparty.com',
        time: '07:54:08.302956',
        adjustment: 105000,
        event: EventName.MANUAL_UPDATE,
        dataInput: 'User',
      },
      {
        updatedBy: null,
        time: '19:00:00',
        adjustment: -24176.48,
        event: EventName.EXPECTED_CONSUMPTION,
        dataInput: 'Forecast',
      },
    ],
    endingInventory: 80823.52,
    endingPercentOfCapacity: 0.2,
    lowInventory: false,
    manualUpdateNeeded: false,
  },
  nextDeliveryExplanation: {
    utcDate: '2025-04-30',
    startingInventory: 80823.52,
    startingPercentOfCapacity: 0.2,
    events: [
      {
        updatedBy: null,
        time: '15:18:11',
        adjustment: 250000,
        event: EventName.DELIVERY,
        dataInput: 'Anteo',
      },
      {
        updatedBy: null,
        time: '19:00:00',
        adjustment: -24166.63,
        event: EventName.EXPECTED_CONSUMPTION,
        dataInput: 'Forecast',
      },
    ],
    endingInventory: 306656.89,
    endingPercentOfCapacity: 0.77,
    lowInventory: true,
    manualUpdateNeeded: null,
  },
};

// Mock PUT request payloads
export const mockOfdSettingsRequest: OfdSettingsRequest = {
  minimumRecommendationQuantity: 1200,
  orderFrequency: 14,
};

export const mockConsumptionRateUpdateRequest: ConsumptionRateUpdateRequest = {
  consumptionRateAdjustmentDays: 10,
  manualConsumptionRateCoefficient: 1.5,
};

export const mockBufferSettingsUpdateRequest: BufferSettingsUpdateRequest = {
  capacityBuffer: 6000,
  consumptionBufferDays: 5,
};

export const mockManualInventoryUpdateRequest: ManualInventoryUpdateRequest = {
  inventory: 125000,
  afterDelivery: false,
};

export const mockInventoryLogResponse: InventoryLog[] = [
  {
    utcDate: '2025-04-25',
    startingInventory: 251081.0,
    events: [
      {
        updatedBy: 'arve_raymond_kleiven@cargill.com',
        time: '09:19:44.620463',
        adjustment: 20000.0,
        event: EventName.MANUAL_UPDATE,
        dataInput: 'User',
      },
      {
        updatedBy: null,
        time: '05:00:00',
        adjustment: -9252.0,
        event: EventName.CONSUMPTION,
        dataInput: 'Fishtalk',
      },
    ],
  },
  {
    utcDate: '2025-04-26',
    startingInventory: 222461.0,
    events: [
      {
        updatedBy: null,
        time: '05:00:00',
        adjustment: -9932.0,
        event: EventName.CONSUMPTION,
        dataInput: 'Fishtalk',
      },
    ],
  },
  {
    utcDate: '2025-05-11',
    startingInventory: 816.0,
    events: [
      {
        updatedBy: null,
        time: '13:30:00',
        adjustment: 42000.0,
        event: EventName.DELIVERY,
        dataInput: 'Anteo',
      },
      {
        updatedBy: null,
        time: '05:00:00',
        adjustment: -9642.0,
        event: EventName.CONSUMPTION,
        dataInput: 'Fishtalk',
      },
    ],
  },
  {
    utcDate: dayjs().format('YYYY-MM-DD'),
    startingInventory: 33174.0,
    events: [],
  },
];

export const mockFeedReserveRequest: FeedReserve[] = [
  {
    feedStrategyId: 0,
    itemNumber: '000000000510951002',
    itemName: 'EWOS RAPID 80 ADAPT 40A',
    fromWeight: 180,
  },
  {
    feedStrategyId: 1,
    itemNumber: '000000000510951089',
    itemName: 'EWOS RAPID MAX HP 200 40A',
    fromWeight: 40,
  },
];

const skippedMockData = () => [];

const openMockData = () => [];

const inventoryMockData = () => [
  {
    date: '2025-07-14T00:00:00Z',
    value: 74039.6,
  },
  {
    date: '2025-07-15T00:00:00Z',
    value: 66685.8,
  },
  {
    date: '2025-07-16T00:00:00Z',
    value: 59288.52,
  },
  {
    date: '2025-07-17T00:00:00Z',
    value: 51857.64,
  },
  {
    date: '2025-07-18T00:00:00Z',
    value: 44398.08,
  },
  {
    date: '2025-07-19T00:00:00Z',
    value: 106911.65,
  },
  {
    date: '2025-07-20T00:00:00Z',
    value: 99400.26,
  },
  {
    date: '2025-07-21T00:00:00Z',
    value: 91865.53,
  },
  {
    date: '2025-07-22T00:00:00Z',
    value: 83603.19,
  },
  {
    date: '2025-07-23T00:00:00Z',
    value: 75317.62,
  },
  {
    date: '2025-07-24T00:00:00Z',
    value: 67002.63,
  },
  {
    date: '2025-07-25T00:00:00Z',
    value: 58683.74,
  },
  {
    date: '2025-07-26T00:00:00Z',
    value: 105862.58,
  },
  {
    date: '2025-07-27T00:00:00Z',
    value: 97540.87,
  },
  {
    date: '2025-07-28T00:00:00Z',
    value: 89220.16,
  },
  {
    date: '2025-07-29T00:00:00Z',
    value: 80173.93,
  },
  {
    date: '2025-07-30T00:00:00Z',
    value: 71129.79,
  },
  {
    date: '2025-07-31T00:00:00Z',
    value: 62100.45,
  },
  {
    date: '2025-08-01T00:00:00Z',
    value: 53056.85,
  },
  {
    date: '2025-08-02T00:00:00Z',
    value: 110000.46,
  },
  {
    date: '2025-08-03T00:00:00Z',
    value: 100932.71,
  },
  {
    date: '2025-08-04T00:00:00Z',
    value: 91854.89,
  },
  {
    date: '2025-08-05T00:00:00Z',
    value: 82034.03,
  },
  {
    date: '2025-08-06T00:00:00Z',
    value: 72203.18,
  },
  {
    date: '2025-08-07T00:00:00Z',
    value: 62396.12,
  },
  {
    date: '2025-08-08T00:00:00Z',
    value: 52561.18,
  },
  {
    date: '2025-08-09T00:00:00Z',
    value: 115699.92,
  },
  {
    date: '2025-08-10T00:00:00Z',
    value: 105813.79,
  },
  {
    date: '2025-08-11T00:00:00Z',
    value: 95904.14,
  },
  {
    date: '2025-08-12T00:00:00Z',
    value: 85227.49,
  },
  {
    date: '2025-08-13T00:00:00Z',
    value: 74527.32,
  },
  {
    date: '2025-08-14T00:00:00Z',
    value: 63817.26,
  },
  {
    date: '2025-08-15T00:00:00Z',
    value: 53105.93,
  },
  {
    date: '2025-08-16T00:00:00Z',
    value: 119894.5,
  },
  {
    date: '2025-08-17T00:00:00Z',
    value: 109183.99,
  },
  {
    date: '2025-08-18T00:00:00Z',
    value: 98475.65,
  },
  {
    date: '2025-08-19T00:00:00Z',
    value: 87018.1,
  },
  {
    date: '2025-08-20T00:00:00Z',
    value: 75563,
  },
  {
    date: '2025-08-21T00:00:00Z',
    value: 64082.21,
  },
  {
    date: '2025-08-22T00:00:00Z',
    value: 52647.26,
  },
  {
    date: '2025-08-23T00:00:00Z',
    value: 122759.52,
  },
  {
    date: '2025-08-24T00:00:00Z',
    value: 111420.44,
  },
  {
    date: '2025-08-25T00:00:00Z',
    value: 100131.19,
  },
  {
    date: '2025-08-26T00:00:00Z',
    value: 88157.19,
  },
  {
    date: '2025-08-27T00:00:00Z',
    value: 76236.11,
  },
  {
    date: '2025-08-28T00:00:00Z',
    value: 64340.9,
  },
];

const consumptionMockData = () => [
  {
    date: '2025-08-17T00:00:00',
    value: 10708.34,
  },
  {
    date: '2025-08-20T00:00:00',
    value: 11480.79,
  },
  {
    date: '2025-07-14T00:00:00',
    value: 7353.8,
  },
  {
    date: '2025-07-15T00:00:00',
    value: 7397.28,
  },
  {
    date: '2025-07-20T00:00:00',
    value: 7534.73,
  },
  {
    date: '2025-07-21T00:00:00',
    value: 8262.34,
  },
  {
    date: '2025-07-18T00:00:00',
    value: 7486.43,
  },
  {
    date: '2025-07-24T00:00:00',
    value: 8318.89,
  },
  {
    date: '2025-07-25T00:00:00',
    value: 8321.16,
  },
  {
    date: '2025-07-29T00:00:00',
    value: 9044.14,
  },
  {
    date: '2025-07-31T00:00:00',
    value: 9043.6,
  },
  {
    date: '2025-08-03T00:00:00',
    value: 9077.82,
  },
  {
    date: '2025-07-23T00:00:00',
    value: 8314.99,
  },
  {
    date: '2025-07-26T00:00:00',
    value: 8321.71,
  },
  {
    date: '2025-08-07T00:00:00',
    value: 9834.93,
  },
  {
    date: '2025-07-30T00:00:00',
    value: 9029.34,
  },
  {
    date: '2025-08-13T00:00:00',
    value: 10710.06,
  },
  {
    date: '2025-08-04T00:00:00',
    value: 9820.86,
  },
  {
    date: '2025-08-08T00:00:00',
    value: 9861.26,
  },
  {
    date: '2025-08-05T00:00:00',
    value: 9830.85,
  },
  {
    date: '2025-08-12T00:00:00',
    value: 10700.17,
  },
  {
    date: '2025-08-18T00:00:00',
    value: 11457.55,
  },
  {
    date: '2025-08-28T00:00:00',
    value: 11845,
  },
  {
    date: '2025-08-02T00:00:00',
    value: 9067.74,
  },
  {
    date: '2025-08-06T00:00:00',
    value: 9807.06,
  },
  {
    date: '2025-07-16T00:00:00',
    value: 7430.87,
  },
  {
    date: '2025-08-09T00:00:00',
    value: 9886.13,
  },
  {
    date: '2025-08-10T00:00:00',
    value: 9909.65,
  },
  {
    date: '2025-08-11T00:00:00',
    value: 10676.65,
  },
  {
    date: '2025-07-17T00:00:00',
    value: 7459.56,
  },
  {
    date: '2025-07-19T00:00:00',
    value: 7511.4,
  },
  {
    date: '2025-07-22T00:00:00',
    value: 8285.58,
  },
  {
    date: '2025-07-27T00:00:00',
    value: 8320.71,
  },
  {
    date: '2025-07-28T00:00:00',
    value: 9046.23,
  },
  {
    date: '2025-08-14T00:00:00',
    value: 10711.33,
  },
  {
    date: '2025-08-15T00:00:00',
    value: 10711.42,
  },
  {
    date: '2025-08-16T00:00:00',
    value: 10710.52,
  },
  {
    date: '2025-08-23T00:00:00',
    value: 11339.08,
  },
  {
    date: '2025-08-01T00:00:00',
    value: 9056.4,
  },
  {
    date: '2025-08-19T00:00:00',
    value: 11455.1,
  },
  {
    date: '2025-08-21T00:00:00',
    value: 11434.95,
  },
  {
    date: '2025-08-24T00:00:00',
    value: 11289.24,
  },
  {
    date: '2025-08-25T00:00:00',
    value: 11974,
  },
  {
    date: '2025-08-26T00:00:00',
    value: 11921.08,
  },
  {
    date: '2025-08-22T00:00:00',
    value: 11387.74,
  },
  {
    date: '2025-08-27T00:00:00',
    value: 11895.21,
  },
];

const ordersMockData = () => [
  {
    date: '2025-07-18T08:28:49Z',
    value: 70000,
  },
];

const forecastedMockData = () => [
  {
    date: '2025-07-25T00:00:00',
    value: 55500,
  },
  {
    date: '2025-08-01T00:00:00',
    value: 66000,
  },
  {
    date: '2025-08-08T00:00:00',
    value: 73000,
  },
  {
    date: '2025-08-15T00:00:00',
    value: 77500,
  },
  {
    date: '2025-08-22T00:00:00',
    value: 81500,
  },
];

export const timelineMockChartData: Timeline = {
  inventory: inventoryMockData(),
  consumption: consumptionMockData(),
  orders: ordersMockData(),
  recommendations: forecastedMockData(),
  skippedRecommendations: skippedMockData(),
  openSlots: openMockData(),
  buffer: 52369,
  siloCapacity: 520000,
};

// export const mockConsumptionRate: ConsumptionRateOptions[] = Array.from({ length: 30 }, (_, i) => ({
//   days: i + 1,
//   kg: Math.floor(Math.random() * (500 - 50 + 1)) + 50,
// })); // Random kg between 50 and 500 }))
export const mockConsumptionRate: ConsumptionRateOptions[] = [
  { days: 3, kg: 25555.87 },
  { days: 4, kg: 26271.87 },
  { days: 5, kg: 24271.87 },
  { days: 6, kg: 25279.27 },
  { days: 7, kg: 29995559.27 },
  { days: 8, kg: 25271.87 },
  { days: 9, kg: 21271.87 },
  { days: 10, kg: 25271.37 },
  { days: 11, kg: 25279.27 },
  { days: 12, kg: 25771.17 },
  { days: 13, kg: 25275.57 },
  { days: 14, kg: 25271.47 },
  { days: 15, kg: 25971.67 },
  { days: 16, kg: 25271.87 },
  { days: 17, kg: 25271.87 },
  { days: 18, kg: 25271.87 },
  { days: 19, kg: 25231.87 },
  { days: 20, kg: 25272.07 },
  { days: 21, kg: 252371.87 },
  { days: 22, kg: 25271.87 },
  { days: 23, kg: 25471.87 },
  { days: 24, kg: 25271.87 },
  { days: 25, kg: 27271.87 },
  { days: 26, kg: 24271.87 },
  { days: 27, kg: 25971.87 },
  { days: 28, kg: 25371.87 },
  { days: 29, kg: 25471.87 },
  { days: 30, kg: 25571.87 },
];
